import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useChatbot } from "../../contexts/chatbot-context";
import { useSidebar } from "../../contexts/sidebar-context";
import s from "./styles.module.scss";
import Sidebar from "../sidebar";
import Chatbot from "../chatbot";

const RightPanel = () => {
  const { pathname } = useLocation();
  const { isExpanded, isDetached } = useChatbot();
  const { isCollapsed } = useSidebar();
  const isCalendarPage = pathname === "/calendar";
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Track window resize for mobile detection
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // On mobile, hide the sidebar completely on all pages
  // Navigation is accessible via the profile picture menu instead
  if (isMobile) {
    return null;
  }

  // On calendar page (desktop/tablet)
  if (isCalendarPage) {
    return (
      <aside className={`${s.rightPanel} ${s.relative} ${isCollapsed ? s.sidebarCollapsed : ''}`}>
        {/* Always render Sidebar - it will handle its own collapsed state */}
        <Sidebar />

        {/* Only render Chatbot here if it's expanded and NOT detached */}
        {isExpanded && !isDetached && <Chatbot />}
      </aside>
    );
  }

  // Non-calendar pages (desktop/tablet)
  return (
    <aside className={s.rightPanel}>
      <Sidebar />
    </aside>
  );
};

export default RightPanel;
